/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type EMRTypes = typeof EMRTypes[keyof typeof EMRTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EMRTypes = {
  Populate: 'Populate',
  ModMed: 'ModMed',
} as const;
